module.exports = __webpack_public_path__ + "static/house-hacking-2x2-b40b47bdddcc855c7f99aaeb241091c7.png";